import { services } from "../data/services";
import { citiesByProvince } from "../data/cities";
import { getHead } from "../seo/routes";
import { provinceIntro } from "../seo/content";
import { Seo } from "../components/Seo";
import { PageHero, Prose, CTABand, Breadcrumbs, LinkGrid } from "../components/Blocks";

export default function ProvincePage({ province }) {
  const path = `/security-guards-${province.slug}`;
  const head = getHead(path, {});
  const pCities = citiesByProvince(province.slug);
  return (
    <>
      <Seo title={head.title} description={head.description} path={path} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Service Areas", to: "/service-areas" }, { label: province.name }]} />
      <PageHero
        overline={`Security Services · ${province.abbr}`}
        title={`Security Guard Services in ${province.name}`}
        lead={`Licensed guards, verified patrols and 24/7 dispatch across ${province.name} — from ${pCities[0].name} to ${pCities[pCities.length - 1].name} and beyond.`}
      />
      <Prose paragraphs={[provinceIntro(province), province.note]} />
      <LinkGrid
        overline="Local Coverage"
        title={`Cities We Serve in ${province.name}`}
        items={pCities.map((c) => ({ to: `/security-guards-${c.slug}`, label: c.name, testid: `province-city-${c.slug}` }))}
      />
      <LinkGrid
        overline="Full Service Line"
        title={`Security Services Available in ${province.name}`}
        cols="grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
        items={services.map((s) => ({ to: `/services/${s.slug}`, label: s.name, testid: `province-service-${s.slug}` }))}
      />
      <CTABand title={`Need Guards in ${province.name}?`} sub={`Our 24/7 dispatch coordinates coverage across ${province.name}. One call starts the process — no forms, no waiting.`} />
    </>
  );
}
